import { useState, useEffect } from 'react';
import axios from 'axios';
import { Search, Loader2 } from 'lucide-react';
import { Input } from '../components/ui/input';
import ProductCard from '../components/ProductCard';
import CategoryFilter from '../components/CategoryFilter';

const API = `https://fastfixbelem.onrender.com/api`;

export default function HomePage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [searchQuery, setSearchQuery] = useState('');
  const [filtroEstoque, setFiltroEstoque] = useState('todos'); // todos | estoque | esgotado

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const params = selectedCategory !== 'Todos' ? { category: selectedCategory } : {};
        const response = await axios.get(`${API}/products`, { params });
        setProducts(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error('Erro ao carregar produtos:', error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [selectedCategory]);

  const filteredProducts = products
    .filter(p => (p?.name || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                 (p?.description || '').toLowerCase().includes(searchQuery.toLowerCase()))
    .filter(p => filtroEstoque === 'todos' ? true : filtroEstoque === 'estoque' ? p.in_stock : !p.in_stock);

  const emEstoque  = products.filter(p => p.in_stock).length;
  const esgotados  = products.filter(p => !p.in_stock).length;

  return (
    <div className="min-h-screen">
      <section className="bg-gradient-to-b from-blue-50 to-white dark:from-slate-900 dark:to-slate-950 py-12 md:py-16">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="text-center space-y-4">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-secondary font-bold tracking-tight text-slate-900 dark:text-white">
              Catálogo de <span className="text-blue-600">Produtos</span>
            </h1>
            <p className="text-base md:text-lg text-slate-600 dark:text-slate-300 max-w-2xl mx-auto">
              Cabos, carregadores, fones e acessórios de informática com qualidade e preço justo.
            </p>
          </div>
          <div className="mt-8 max-w-md mx-auto">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
              <Input type="text" placeholder="Buscar produtos..." value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-10 h-12 rounded-full border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900"/>
            </div>
          </div>
        </div>
      </section>

      <section className="py-8 md:py-12">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <CategoryFilter selected={selectedCategory} onSelect={setSelectedCategory}/>

          {/* Filtro estoque */}
          <div className="flex gap-2 mb-6 flex-wrap">
            {[
              { id:'todos',    label:`Todos (${products.length})` },
              { id:'estoque',  label:`✅ Em estoque (${emEstoque})` },
              { id:'esgotado', label:`⏳ Esgotado (${esgotados})` },
            ].map(f => (
              <button key={f.id} onClick={() => setFiltroEstoque(f.id)}
                className={`text-xs px-4 py-2 rounded-full font-medium transition-all border ${
                  filtroEstoque === f.id
                    ? 'bg-blue-600 text-white border-blue-600 shadow-sm'
                    : 'bg-white dark:bg-slate-900 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-700 hover:border-blue-400'
                }`}>
                {f.label}
              </button>
            ))}
          </div>

          {loading ? (
            <div className="flex items-center justify-center py-20">
              <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
            </div>
          ) : filteredProducts.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-slate-500 dark:text-slate-400">Nenhum produto encontrado.</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {filteredProducts.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
